import { render, staticRenderFns } from "./teamMember.vue?vue&type=template&id=99b89eaa&scoped=true&"
import script from "./teamMember.vue?vue&type=script&lang=js&"
export * from "./teamMember.vue?vue&type=script&lang=js&"
import style0 from "./teamMember.vue?vue&type=style&index=0&id=99b89eaa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99b89eaa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('99b89eaa')) {
      api.createRecord('99b89eaa', component.options)
    } else {
      api.reload('99b89eaa', component.options)
    }
    module.hot.accept("./teamMember.vue?vue&type=template&id=99b89eaa&scoped=true&", function () {
      api.rerender('99b89eaa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-299z7wGPT8D3m/JS/teamMember.vue"
export default component.exports